import React, { useEffect, useState, useContext, useRef, useCallback, useMemo } from 'react'
import { cloneDeep, debounce, isEqual } from 'lodash'
import Layout from '@/custom/components/templates/Layout'
import SearchComp from '../Search/SearchComp'
import SavedSearch from '../Search/SavedSearch'
// import FilterPanel from '@/product/components/species/dynamic/common/FilterPanel/Filter'
import SortbyCom from '../Search/SortbyComp'
import { Badge, Button, ListItem, Popover, useMediaQuery } from '@material-ui/core'
import { Drawer } from '@material-ui/core'
import { useFormik } from 'formik'
import Filters from '../Dashboard/MyAuctions/SortbyComp'
import AuthContext from '@/product/context/auth/authContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import Commoncomp from '../Dashboard/MyAuctions/SortbyComp'
import { handleRedirectInternal } from '@/custom/common/components'
import { useLocation, useHistory, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import SEO from '@/utils/SEO'
import { initialSearchFunction } from '../../product/components/species/dynamic/common/FieldFunction'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import { ShowChart } from '@material-ui/icons'
import Banner from '../../custom/components/molecules/Banner'
import ReviewComponent from '@/product/components/species/components/general/ReviewComponent'
import CustomSelect from '@/product/components/atoms/Inputs/CustomSelect'
import { filterCategories } from '@/utils/common'
import CustomDrawer from '@/custom/components/molecules/CustomDrawer'
import ProductContext from '@/product/context/product/productContext'
import openSocket from 'socket.io-client'
import { messageHandler } from '@/product/common/socketHandler'
import ProductsSlider from '@/custom/components/molecules/ProductsSlider'
import Slider from 'react-slick'
import NoRecordsFound from '@/product/components/atoms/NoRecordsFound'
import ProductCommonContext from '@/product/context/common/commonContext'
import GridView from '@/custom/components/molecules/ProductCard/GridView'
import customCommonContext from '@/custom/context/common/commonContext'
import AlertContext from '@/product/context/alert/alertContext'
import { isPointWithinRadius } from 'geolib'
import './Home.css'
import { FALLBACK_IMAGE } from '@/utils'
import Loaders from '@/custom/components/molecules/Loaders'
import { Autocomplete } from '@/custom/components/molecules/Header/autocomplete'
import FilterPanel from '@/custom/common/FilterPanel'
import { mapData } from '@/product/common/components'
import { getAlgoliaResults } from '@algolia/autocomplete-js'
import commonContext from '@/custom/context/common/commonContext'
import algoliasearch from 'algoliasearch'
import invoiceContext from '@/product/context/invoice/invoiceContext'
import AllListings from '@/custom/common/AllListings'
import CustomDialog from '@/custom/components/organisms/CustomDialog'
import SignContext from '@/custom/context/signContext'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
const price = [
    {
        value: 'p.date_closed,ASC',
        show: 'Ending Soonest',
    },
    {
        value: 'p.date_closed,DESC',
        show: 'Ending Latest',
    },
    {
        value: 'it.asin_price,ASC',
        show: 'Retail Value Low to High',
    },
    {
        value: 'it.asin_price,DESC',
        show: 'Retail Value High to Low',
    },
    {
        value: '15',
        show: 'Offer Price Low to High',
    },
    {
        value: '14',
        show: 'Offer Price High to Low',
    },
    {
        value: '6',
        show: 'Buy It Now Price Low to High',
    },
    {
        value: '7',
        show: 'Buy It Now Price High to Low',
    },
    {
        value: '20',
        show: `Today's Steal`,
    },
]
let randomVariable = Math.random()
const Home = (props) => {
    const location = useLocation()
    const { t } = useTranslation()
    const [drawerOpen, setDrawerOpen] = useState(false)
    const authContext = useContext(AuthContext)
    const [updated, setUpdated] = useState(false)
    const [isProductLoading, setIsProductLoading] = useState(true)
    const locationFilterProcessed = useRef(false)
    const conditionFilterProcessed = useRef(false)
    const categoryFilterProcessed = useRef(false)
    const dynamicContext = useContext(DynamicContext)
    const productContext = useContext(ProductContext)

    const {
        search_allproducts,
        search_alldashboardproducts,
        getAllSearchProducts,
        responseStatus,
        active_sorts,
        getAllActiveSorts,
    } = productContext
    const CustomCommonContext = useContext(customCommonContext)
    const { getGlobalVariable, alldata_all_dropdown, allLocations, allCategory } =
        CustomCommonContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const signContext = useContext(SignContext)
    const { setRegisterPopup } = signContext
    const [dynamicArray, setDynamicArray] = useState([])
    const [initialValues, setInitialValues] = useState({})
    const [initialEmptyValues, setInitialEmptyValues] = useState({})
    const [arrayValue, setArrayValue] = useState([])
    const [reload, setReload] = useState(false)
    const { user, isAuthenticated, cartCount } = authContext
    const [callFunction, setCallFunction] = useState(false)
    const [show, setShow] = useState(false)
    const [initialUpdate, setInitialUpdate] = useState(false)
    const [initialLoad, setInitialLoad] = useState(false)
    const [condition, setCondition] = useState([])
    const [showFiltered, setShowFiltered] = useState(false)
    // const [viewTrending, setViewTrending] = useState([])
    const [viewFeatured, setViewFeatured] = useState([])

    const [locationData, setLocationData] = useState([])
    const [filtersLoaded, setFiltersLoaded] = useState(false)
    let params = new URLSearchParams(window.location.search)
    const locationUrl = useLocation()
    const toggleDrawer = () => setDrawerOpen(!drawerOpen)
    const history = useHistory()

    function NextArrow(props) {
        const { onClick } = props
        return (
            <button type="button" className="slick-next" onClick={onClick}>
                <svg
                    width="20"
                    height="30"
                    viewBox="0 0 7 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M0 10H3.22L6.79 5L3.22 0H0L3.58 5L0 10Z" fill={props.fill} />
                </svg>
            </button>
        )
    }

    function PrevArrow(props) {
        const { onClick } = props
        return (
            <button type="button" className="slick-prev" onClick={onClick}>
                <svg
                    width="20"
                    height="30"
                    viewBox="0 0 7 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.78906 10H3.56906L-0.000937462 5L3.56906 0H6.78906L3.20906 5L6.78906 10Z"
                        fill={props.fill}
                    />
                </svg>
            </button>
        )
    }

    const catSettings = {
        infinite: false,
        dots: false,
        centerMode: false,
        arrows: true,
        slidesToShow: 8,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 4000,
        initialSlide: 0,
        speed: 500,
        adaptiveHeight: false,
        cssEase: 'ease-in-out',
        swipeToSlide: true,
        touchThreshold: 10,
        nextArrow: <NextArrow fill="white" />,
        prevArrow: <PrevArrow fill="white" />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    centerMode: false,
                    arrows: false,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    centerMode: false,
                    arrows: false,
                },
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    centerMode: false,
                    arrows: false,
                },
            },
        ],
    }

    const featuredSettings = {
        infinite: true,
        speed: 800,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        // autoplaySpeed: 3000,
        adaptiveHeight: true,
        dots: false,
        centerPadding: '155px',
        arrows: true,
        centerMode: true,
        nextArrow: <NextArrow fill="black" />,
        prevArrow: <PrevArrow fill="black" />,
        cssEase: 'linear',
        waitForAnimate: false,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    centerMode: true,
                },
            },
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '115px',
                },
            },
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '80px',
                },
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '145px',
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '130px',
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '120px',
                },
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '140px',
                },
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '100px',
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '80px',
                    arrows: false,
                },
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '40px',
                    arrows: false,
                },
            },
            {
                breakpoint: 475,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '30px',
                    arrows: false,
                },
            },
            {
                breakpoint: 430,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '55px',
                    arrows: false,
                },
            },
            {
                breakpoint: 414,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '52px',
                    arrows: false,
                },
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '25px',
                    arrows: false,
                },
            },
            {
                breakpoint: 392,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '48px',
                    arrows: false,
                },
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '42px',
                    arrows: false,
                },
            },
            {
                breakpoint: 360,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '50px',
                    arrows: false,
                },
            },
            {
                breakpoint: 350,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '35px',
                    arrows: false,
                },
            },
        ],
    }

    const isMobile = useMediaQuery('(max-width:768px)')
    const [auctionView, setAuctionView] = useState('Grid')

    // const getSearchBarObjet = (value) => {
    //     return {
    //         limit: 12,
    //         page: 1,
    //         orderby: 'p.id, desc',
    //         order: '',
    //         filters: {
    //             searchbar: {
    //                 value: value,
    //                 type: 'like',
    //                 field: 'p.title,p.desc_proc',
    //             },
    //         },
    //     }
    // }

    const formikSearch = useFormik({
        initialValues: {
            limit: 50,
            page: 1,
            orderby: 'p.date_closed,ASC',
            order: '',
            auctionView: 'Grid',
            filters: initialValues,
            inCartProducts: true,
            // INFINITE SCROLL - Commented out for pagination
            // infinite: false,
            // market_status: ['open']
        },
        enableReinitialize: true,
        onSubmit: (values) => {
            values.searchCategories = values.filters.searchbar.value ? true : false
            setIsProductLoading(true)
            randomVariable = Math.random()
            getAllSearchProducts(values, randomVariable, 'custom/')
        },
    })

    useEffect(() => {
        if (search_allproducts?.from === randomVariable) {
            setIsProductLoading(false)
        }
    }, [search_allproducts])

    // Auto-open signup popup when ?signup=true is in URL
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        if (searchParams.get('signup') === 'true') {
            setTimeout(() => {
                setRegisterPopup(true)
            }, 100)
        }
    }, [location.search])

    const [searchText, setSearchText] = useState('')

    // const handleSearchAutocompleteTextChange = (item, reset) => {
    //     console.log(item, 'itemitem', location.pathname)
    //     let searchQuery = reset ? '' : item.state.query

    //     setSearchText(item.state.query)
    //     let query = generateQueryParams('search', searchQuery)
    //     if (searchQuery !== '') {
    //         if (location.pathname !== '/search') {
    //             handleRedirectInternal(history, `search?${query}`)
    //         } else {
    //             setSearchValue(getSearchBarObjet(searchQuery))
    //             history.push(`search?${query}`)
    //         }
    //     } else {
    //         setSearchValue(getSearchBarObjet(''))
    //         if (location.pathname === '/search') {
    //             history.push(`search?${query}`)
    //         }
    //     }
    //     return true
    // }

    const formikFeatured = useFormik({
        initialValues: {
            limit: 12,
            page: 1,
            orderby: '13',
            order: '',
            auctionView: 'Grid',
            filters: {
                searchbar: {
                    value: '',
                    type: 'like',
                    field: 'p.title',
                },
                featured: {
                    value: '',
                    type: 'in',
                    field: 'p.featured',
                },
                category: {
                    value: '',
                    type: 'in',
                    field: 'it.category',
                },
                timing: {
                    value: '',
                    type: 'in',
                },
                distance: {
                    value: '',
                    type: 'custom',
                },
                location: {
                    value: '',
                    type: 'in',
                    field: 'it.location',
                },
                conditionTypeId: {
                    value: '',
                    type: 'in',
                    field: 'it.conditionTypeId',
                },
                price: {
                    value: '',
                    type: 'in',
                    field: 'p.wprice',
                },
            },
        },
        enableReinitialize: true,
        onSubmit: (values) => {
            getAllSearchProducts(values, 'featured', 'custom/')
        },
    })

    const appId = process.env.REACT_APP_ALGOLIA_APPID
    const apiKey = process.env.REACT_APP_ALGOLIA_APIKEY
    const searchClient = algoliasearch(appId, apiKey)
    useEffect(() => {
        const filterCheckField = [
            'date_added',
            'date_closed',
            'category',
            'conditionTypeId',
            'location',
        ]
        let finalResult = false
        if (
            formikSearch.values.radius ||
            formikSearch.values.longitude ||
            formikSearch.values.latitude
        ) {
            finalResult = true
        }
        if (formikSearch.values.filters) {
            filterCheckField.forEach((ele) => {
                const value = formikSearch.values.filters[ele]?.value

                if (
                    (Array.isArray(value) && value.length > 0) || // non-empty array
                    (!Array.isArray(value) && value) // truthy non-array value
                ) {
                    finalResult = true
                }
            })

            setShowFiltered(finalResult)
        }
    }, [formikSearch.values])

    const handleFormikChange = async (field, value, filterdata, isArrayValue = false) => {
        value = Array.isArray(value) && isArrayValue ? value.flat() : value
        if (field) {
            if (filterdata) {
                if (Array.isArray(value) && value.length) {
                    formikSearch.setFieldValue(`filters.${field}.value`, value)
                } else if (isArrayValue) {
                    formikSearch.setFieldValue(`filters.${field}.value`, [])
                } else {
                    formikSearch.setFieldValue(`filters.${field}.value`, value || '')
                }
            } else {
                formikSearch.setFieldValue(field, value)
            }
            // INFINITE SCROLL - Commented out for pagination
            // formikSearch.setFieldValue(`infinite`, false)
            if (
                isArrayValue ||
                field == 'location' ||
                field == 'searchbar' ||
                field == 'conditionTypeId' ||
                field == 'category'
            ) {
                formikSearch.setFieldValue('page', 1)
                formikSearch.values.page = 1
            }
            formikSearch.handleSubmit()

            params.delete(field)

            if (Array.isArray(value) && value.length) {
                value.forEach((v) => params.append(field, v))
            } else if (value !== undefined && value !== null && value !== '') {
                params.set(field, value)
            }

            history.replace({
                pathname: location.pathname,
                search: params.toString(),
            })
        }
    }

    // useEffect(() => {
    //     if (searchValue && searchValue.filters && searchValue.filters.searchbar) {
    //         setSearchText(searchValue.filters.searchbar.value)
    //     }
    // }, [searchValue])

    useEffect(() => {
        if (props?.homePage) {
            formikFeatured.handleSubmit()
            formikSearch.resetForm({
                values: {
                    ...formikSearch.initialValues,
                    orderby: 'p.date_closed,ASC',
                    filters: initialEmptyValues,
                },
            })
            formikSearch.handleSubmit()
        }
    }, [props?.homePage])

    const userRef = useRef(user)
    const viewFeaturedRef = useRef(viewFeatured)

    useEffect(() => {
        userRef.current = user
        viewFeaturedRef.current = viewFeatured
    })

    useEffect(() => {
        getAllActiveSorts({})
        setInitialValues({})
        setInitialEmptyValues({})
        setInitialUpdate(false)
        setCallFunction(false)
    }, [])

    useEffect(() => {
        console.log('iiiiiiiiiiiiiiiii11222222222222')
        if (localStorage.getItem('clearSearch')) {
            console.log('iiiiiiiiiiiiiiiii3333333333333333')
            formikSearch.resetForm({
                values: {
                    ...formikSearch.initialValues,
                    orderby: 'p.date_closed,ASC',
                    filters: initialEmptyValues,
                },
            })
            if (formikSearch.values.filters?.keywords?.value) {
                formikSearch.values.filters.keywords.value = ''
            }
            formikSearch.handleSubmit()
            localStorage.removeItem('clearSearch')
        }
    }, [localStorage.getItem('clearSearch')])

    const handlerFeatured = (message, type) => {
        messageHandler(
            message,
            viewFeaturedRef.current,
            userRef.current,
            null,
            setViewFeatured,
            type,
            null,
            global?.successBidMessage,
        )
    }

    // const trendingProductsBidCountChange = (socketData) => {
    //     if (socketData?.bpop_bidcount && viewFeaturedRef.current?.length) {
    //         const highestBidProduct = viewFeaturedRef.current.reduce((prev, current) => {
    //             return prev.bidCount > current.bidCount ? prev : current
    //         })

    //         if (socketData.bpop_bidcount > highestBidProduct?.bidCount) {
    //             formikFeatured.handleSubmit()
    //         }
    //     }
    // }

    useEffect(() => {
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`, {
            transports: ['websocket'],
        })
        socket.on('realclosedupdates', (data) => {
            data['date_closed'] = new Date().toISOString()
            data['bpop_belowFiveIncrement'] = new Date().toISOString()
            handlerFeatured(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            handlerFeatured(data, 'bidAddtime')
        })
        socket.on('cancelBidEmitted', (data) => {
            if (
                data?.project_id &&
                viewFeatured?.some((featured) => featured?.id === data?.project_id)
            ) {
                formikFeatured.handleSubmit()
            }
        })

        return () => {
            socket.off('realclosedupdates', (data) => {
                data['date_closed'] = new Date().toISOString()
                data['bpop_belowFiveIncrement'] = new Date().toISOString()
                handlerFeatured(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                handlerFeatured(data, 'bidAddtime')
            })
            socket.off('cancelBidEmitted', (data) => {
                if (
                    data?.project_id &&
                    viewFeatured?.some((featured) => featured?.id === data?.project_id)
                ) {
                    formikFeatured.handleSubmit()
                }
            })
            socket.disconnect()
        }
    }, [])

    const [count, setCount] = useState({
        bidsCount: 0,
        buynowCount: 0,
        watchlistCount: 0,
    })

    useEffect(() => {
        if (cartCount?.bidsCount) {
            setCount({ ...count, bidsCount: cartCount.bidsCount.totalRecords })
        }
        if (cartCount?.buynowCount) {
            setCount({ ...count, buynowCount: cartCount.buynowCount.totalRecords })
        }
        if (cartCount?.watchlistCount) {
            setCount({ ...count, watchlistCount: cartCount.watchlistCount.totalRecords })
        }
    }, [cartCount])

    useEffect(() => {
        if (search_allproducts && search_allproducts.from === 'featured') {
            if (search_allproducts.records.length) {
                setViewFeatured(search_allproducts.records)
            } else {
                setViewFeatured([])
            }
        }
    }, [search_allproducts])

    const clearSearchFilter = () => {
        formikSearch.resetForm({
            values: {
                ...formikSearch.initialValues,
                orderby: 'p.date_closed,ASC',
                filters: initialEmptyValues,
                page: 1,
            },
        })
        setSearchText('')
        if (formikSearch.values.filters?.keywords?.value) {
            formikSearch.values.filters.keywords.value = ''
        }
        formikSearch.handleSubmit()

        setShow(true)

        const rootUrl = window.location.origin
        const newUrl = new URL(rootUrl)
        window.history.replaceState({}, document.title, newUrl.href)
    }

    // const [category, setCategory] = useState([])

    useEffect(() => {
        const processLocations = () => {
            if (allLocations.length) {
                let dropValues = allLocations
                    .filter((main) => {
                        if (
                            active_sorts &&
                            active_sorts.sorts &&
                            active_sorts.sorts.sortlocations
                        ) {
                            return active_sorts.sorts.sortlocations.includes(main.id.toString())
                        }
                        return false
                    })
                    .filter((data) => data.active == 1)
                    .map((location) => {
                        let locationChanged = {}
                        locationChanged.show = location.name
                        locationChanged.value = location.id.toString()
                        locationChanged.id = location.id.toString()
                        locationChanged.description = location.name
                        return locationChanged
                    })
                setLocationData(dropValues)
            } else {
                setLocationData([])
            }

            locationFilterProcessed.current = true
        }

        try {
            processLocations()
        } catch (error) {
            console.error('Error processing locations:', error)
            locationFilterProcessed.current = true
        }
    }, [allLocations, active_sorts])

    // useEffect(() => {
    //     const processCategory = () => {
    //         if (allCategory.length) {
    //             let dropvalues = allCategory
    //                 .filter((main) => {
    //                     if (
    //                         main.level === 0 &&
    //                         main.active === 1 &&
    //                         (active_sorts &&
    //                         active_sorts.sorts &&
    //                         active_sorts.sorts.sortcategorytypes
    //                             ? active_sorts.sorts.sortcategorytypes?.includes(main.id.toString())
    //                             : true)
    //                     ) {
    //                         return true
    //                     }
    //                 })
    //                 .map((location) => {
    //                     let locationChanged = {}
    //                     locationChanged.show = location.description
    //                     locationChanged.value = location.id.toString()
    //                     locationChanged.img_src = `${global.images_url}${location?.avatar}`
    //                     locationChanged.show_order = location.show_order
    //                     locationChanged.id = location.id.toString()
    //                     locationChanged.description = location.description

    //                     return locationChanged
    //                 })
    //                 .sort((a, b) => a.show_order - b.show_order)
    //             if (dropvalues && dropvalues.length) {
    //                 setCategory(dropvalues)
    //             } else {
    //                 setCategory([])
    //             }
    //         }
    //         categoryFilterProcessed.current = true
    //     }

    //     try {
    //         processCategory()
    //     } catch (error) {
    //         console.error('Error processing Category:', error)
    //         categoryFilterProcessed.current = true
    //     }
    // }, [allCategory, active_sorts])

    const category = useMemo(() => {
        if (!allCategory.length) {
            categoryFilterProcessed.current = true
            return []
        }

        let dropvalues = allCategory
            .filter((main) => {
                if (main.level === 0 && main.active === 1) {
                    if (
                        active_sorts &&
                        active_sorts.sorts &&
                        active_sorts.sorts.sortcategorytypes
                    ) {
                        return active_sorts.sorts.sortcategorytypes.includes(main.id.toString())
                    }
                    return true
                }
                return false
            })
            .map((location) => ({
                show: location.description,
                value: location.id.toString(),
                img_src: `${global.images_url}${location?.avatar}`,
                show_order: location.show_order,
                id: location.id.toString(),
                description: location.description,
            }))
            .sort((a, b) => a.show_order - b.show_order)

        categoryFilterProcessed.current = true
        return dropvalues
    }, [allCategory, active_sorts])

    useEffect(() => {
        const processCondition = () => {
            if (alldata_all_dropdown.length) {
                let conditionVal = alldata_all_dropdown
                    .filter((main) => {
                        if (
                            main.level === 0 &&
                            main.variable == 'conditionTypeId' &&
                            (active_sorts &&
                            active_sorts.sorts &&
                            active_sorts.sorts.sortconditiontypes
                                ? active_sorts.sorts.sortconditiontypes.includes(main.id.toString())
                                : true)
                        ) {
                            return true
                        }
                    })
                    .map((location) => {
                        let locationChanged = {}
                        locationChanged.show = location.description
                        locationChanged.value = location.id.toString()
                        locationChanged.show_order = location.show_order
                        locationChanged.id = location.id.toString()
                        locationChanged.description = location.description
                        return locationChanged
                    })
                if (conditionVal && conditionVal.length) {
                    setCondition(conditionVal)
                } else {
                    setCondition([])
                }
            }
            conditionFilterProcessed.current = true
        }

        try {
            processCondition()
        } catch (error) {
            console.error('Error processing Condition:', error)
            conditionFilterProcessed.current = true
        }
    }, [alldata_all_dropdown, active_sorts])

    useEffect(() => {
        if (params.get('orderby')) {
            // formikSearch.resetForm({
            //     values: {
            //         ...formikSearch.initialValues,
            //         orderby: 'p.date_closed,ASC',
            //         filters: initialEmptyValues,
            //     },
            // })
            if (formikSearch.values?.filters?.keywords) {
                formikSearch.setFieldValue('filters.keywords', {
                    value: [],
                    type: 'arraylike',
                    field: 'it.keywords',
                })
                formikSearch.values.filters.keywords = {
                    value: [],
                    type: 'arraylike',
                    field: 'it.keywords',
                }
            }

            formikSearch.setFieldValue('orderby', params.get('orderby'))
            formikSearch.handleSubmit()
        }
    }, [params.get('orderby')])

    useEffect(() => {
        if (params.get('searchbar')) {
            setSearchText(params.get('searchbar'))
            formikSearch.setFieldValue(`filters.searchbar.value`, params.get('searchbar'))
            // INFINITE SCROLL - Commented out for pagination
            // formikSearch.setFieldValue(`infinite`, false)
            formikSearch.values.page = 1
            formikSearch.setFieldValue('page', 1)
            formikSearch.handleSubmit()
        } else {
            setSearchText('')
        }
    }, [params.get('searchbar')])

    const updateFormikFromUrl = async () => {
        const urlParams = new URLSearchParams(locationUrl.search)
        const params = new URLSearchParams()

        // Collect values from URL parameters
        const collectedParams = {}
        urlParams.forEach((value, key) => {
            if (!collectedParams[key]) {
                collectedParams[key] = []
            }
            collectedParams[key].push(value)
        })

        const entries = Object.entries(collectedParams)
        console.log('iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii', entries, entries.length)
        for (let i = 0; i < entries.length; i++) {
            const [key, values] = entries[i]
            const currentSalesSection = document.querySelector('.current-sales-section')

            if (formikSearch.values.filters[key]?.type === 'array') {
                currentSalesSection?.scrollIntoView({ behavior: 'smooth' })
                formikSearch.setFieldValue(`filters.${key}.value`, values)
            } else if (key === 'orderby') {
                currentSalesSection?.scrollIntoView({ behavior: 'smooth' })
                formikSearch.setFieldValue(`orderby`, values[0])
            } else if (key === 'trending') {
                const trendingSection = document.querySelector('.trending-section')
                if (trendingSection) {
                    trendingSection.scrollIntoView({ behavior: 'smooth' })
                }
            } else {
                currentSalesSection?.scrollIntoView({ behavior: 'smooth' })
                formikSearch.setFieldValue(`filters.${key}.value`, values[0])
            }

            if (Array.isArray(values) && values.length) {
                values.forEach((v) => params.append(key, v))
            } else if (values[0] !== undefined && values[0] !== null) {
                params.set(key, values[0])
            }
        }

        history.replace({
            pathname: location.pathname,
            search: params.toString(),
        })
    }

    useEffect(() => {
        if (
            locationFilterProcessed.current &&
            categoryFilterProcessed.current &&
            conditionFilterProcessed.current
        ) {
            let custom = {
                searchbar: {
                    value: '',
                    // type: 'like',
                    // field: 'p.title,it.keywords',
                },
                date_added: {
                    value: '',
                    type: 'datetimegreaterequal',
                    field: 'p.date_closed',
                },
                date_closed: {
                    value: '',
                    type: 'datetimesmallerequal',
                    field: 'p.date_closed',
                },
                featured: {
                    value: '',
                    type: 'in',
                    field: 'p.featured',
                },
                category: {
                    value: [],
                    type: 'array',
                    field: 'it.category',
                },

                distance: {
                    value: '',
                    type: 'in',
                },
                location: {
                    value: [],
                    type: 'array',
                    field: 'it.location',
                },
                conditionTypeId: {
                    value: [],
                    type: 'array',
                    field: 'it.conditionTypeId',
                },
                price: {
                    value: '',
                    type: 'in',
                    field: 'p.wprice',
                },
                multiplelocation: {
                    value: '',
                    type: 'array',
                    field: 'it.location',
                },
            }
            setInitialValues(custom)
            setInitialEmptyValues(custom)
            setFiltersLoaded(true)
        }
    }, [
        locationFilterProcessed.current,
        categoryFilterProcessed.current,
        conditionFilterProcessed.current,
    ])

    useEffect(() => {
        if (filtersLoaded) {
            setInitialUpdate(true)
            setReload(!reload)
            setCallFunction(true)
            setUpdated(true)
            setInitialLoad(true)
        }
    }, [filtersLoaded])

    useEffect(() => {
        if (callFunction) {
            formikSearch.resetForm({
                values: {
                    ...formikSearch.initialValues,
                    orderby: 'p.date_closed,ASC',
                    filters: initialEmptyValues,
                },
            })
            updateFormikFromUrl()
        }
    }, [callFunction])

    // const generateQueryParams = (type, id) => {
    //     let queryObject = {}
    //     if (type === 'category') {
    //         queryObject.category = id
    //     }
    //     const params = new URLSearchParams(queryObject)
    //     return params.toString()
    // }

    // const handleCategory = (data) => {
    //     let query = generateQueryParams('category', data)
    //     handleRedirectInternal(history, `search?${query}`)
    // }

    const filterFilelds = {
        formik: formikSearch,
        data: [
            {
                label: 'Category',
                placeholder: 'Enter Category',
                type: 'multiselect',
                class: 'filt p-0',
                options: category,
                name: 'category',
                filter: true,
                onChange: (event, value) => {
                    handleFormikChange(`category`, value, 1, true)
                },
                onlyShowLable: true,
                enableSearch: true,
            },
            {
                label: 'Condition',
                placeholder: 'Enter Condition',
                type: 'multiselect',
                class: 'filt p-0',
                options: condition,
                name: 'conditionTypeId',
                filter: true,
                onChange: (event, value) => {
                    handleFormikChange(`conditionTypeId`, value, 1, true)
                },
                onlyShowLable: true,
            },
            {
                label: 'Ending Soonest',
                placeholder: 'Price/Time',
                type: 'select',
                class: 'filt p-0 marginLess',
                options: price,
                name: 'orderby',
                filter: false,
                onChange: (event, value) => {
                    handleFormikChange(`orderby`, value)
                },
                // isNoDefaultOptionValue: true,
            },
            {
                label: 'Calender',
                placeholder: 'Price/Time',
                type: 'select',
                calender: true,
                class: 'filt p-0 marginLess',
                options: price,
                name: 'orderby',
                filter: false,
                onChange: (event, value) => {
                    handleFormikChange(`orderby`, value)
                },
                // isNoDefaultOptionValue: true,
            },
        ],
    }

    const arraysEqual = (a, b) => {
        if (a.length !== b.length) return false
        return a.every((val, index) => val === b[index])
    }

    useEffect(() => {
        let newValues = {
            ...formikSearch.values,
            // orderby: 'p.date_closed,ASC',
            // filters: initialEmptyValues,
        }
        let hasChanges = false
        let keywords = params.get('keywords')
        if (keywords) {
            newValues = {
                ...formikSearch.values,
                orderby: 'p.date_closed,ASC',
                filters: initialEmptyValues,
            }
            keywords = keywords.split(',')
            const existingKeywords = formikSearch?.values?.filters?.keywords?.value || []
            if (!arraysEqual(existingKeywords, keywords)) {
                newValues.filters.keywords = {
                    value: keywords,
                    type: 'arraylike',
                    field: 'it.keywords',
                }
                hasChanges = true
                const rootUrl = window.location.origin
                const newUrl = new URL(rootUrl)
                // window.history.replaceState({}, document.title, newUrl.href)
            }
        }
        ;['longitude', 'latitude', 'radius'].forEach((key) => {
            const value = params.get(key)
            if (value && formikSearch.values[key] !== value) {
                newValues[key] = value
                hasChanges = true
            }
        })

        if (hasChanges) {
            formikSearch.setValues(newValues)
            // INFINITE SCROLL - Commented out for pagination
            // formikSearch.setFieldValue(`infinite`, false)
            formikSearch.handleSubmit()
        }
    }, [params])

    const categorySec = useRef(null)

    return (
        <Layout>
            {initialUpdate ? (
                <div className="homeCnt">
                    {props?.homePage ? (
                        <div className="home">
                            <div className="customContainer">
                                <section className="heroBanner">
                                    <Banner />
                                    {category.length > 0 && (
                                        <div className="categories-list">
                                            <div className="bannerOverlay">
                                                <div className="categoryWrapper customContainer">
                                                    <Slider lazyLoad="ondemand" {...catSettings}>
                                                        {category?.map((cat, index) => (
                                                            <button
                                                                className="category-btn"
                                                                type="button"
                                                                key={index}
                                                                onClick={() => {
                                                                    // Scroll into view
                                                                    categorySec.current?.scrollIntoView(
                                                                        { behavior: 'smooth' },
                                                                    )

                                                                    // Handle formik change
                                                                    handleFormikChange(
                                                                        'category',
                                                                        [cat?.value?.toString()],
                                                                        1,
                                                                        true,
                                                                    )
                                                                }}
                                                            >
                                                                <div className="button-content">
                                                                    <img
                                                                        className="category_image"
                                                                        src={cat.img_src}
                                                                        alt={cat.show}
                                                                        onError={(e) =>
                                                                            FALLBACK_IMAGE(e)
                                                                        }
                                                                    />
                                                                    <span>{cat.show}</span>
                                                                </div>
                                                            </button>
                                                        ))}
                                                    </Slider>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </section>
                            </div>
                        </div>
                    ) : null}

                    <div className="search">
                        <div className="">
                            {props?.homePage && viewFeatured?.length ? (
                                <div className="trending-wrapper customContainer featuredTrending">
                                    <div className="featureBg">
                                        <div className="home-content-head featuredHead">
                                            Featured Items
                                        </div>
                                        <div className="featured">
                                            {viewFeatured.slice(0, 20)?.length ? (
                                                <Slider {...featuredSettings}>
                                                    {viewFeatured.map((data, index) => (
                                                        <div className="slider-item" key={index}>
                                                            <GridView
                                                                data={data}
                                                                featured
                                                                favId={`searchProd_${index}`}
                                                            />
                                                        </div>
                                                    ))}
                                                </Slider>
                                            ) : (
                                                <NoRecordsFound />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                            <div ref={categorySec}></div>
                            <AllListings
                                filterFilelds={filterFilelds}
                                from={randomVariable}
                                clearSearchFilter={clearSearchFilter}
                                searchText={searchText}
                                setSearchText={setSearchText}
                                // ref={categorySec}
                                // handleSearchAutocompleteTextChange={
                                //     handleSearchAutocompleteTextChange
                                // }
                                toggleDrawer={toggleDrawer}
                                count={count}
                                formikSearch={formikSearch}
                                updated={updated}
                                auctionView={auctionView}
                                drawerOpen={drawerOpen}
                                show={show}
                                arrayValue={arrayValue}
                                handleFormikChange={handleFormikChange}
                                searchClient={searchClient}
                                initialLoad={initialLoad}
                                setInitialLoad={setInitialLoad}
                                filtersLoaded={filtersLoaded}
                                condition={condition}
                                locationData={locationData}
                                category={category}
                                isProductLoading={isProductLoading}
                                setIsProductLoading={setIsProductLoading}
                            />
                            {showFiltered && (
                                <div
                                    className="clearAllButton"
                                    id="checkout_pay_make"
                                    onClick={() => {
                                        clearSearchFilter()
                                    }}
                                >
                                    <span>Clear All Filters</span>
                                </div>
                                // <SecondaryButton
                                //     className=""
                                //     btnSize="small fixedclearAll"
                                //     id="checkout_pay_make"
                                //     onClick={() => {
                                //         clearSearchFilter()
                                //     }}
                                //     // disabled={props.isCouponLoading}
                                //     label="Clear All Filter"
                                // >
                                //     {/* <span className="material-icons-outlined mr-2">clear_all</span> */}
                                //     {/* <p className="m-0">Clear All Filter</p> */}
                                // </SecondaryButton>
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                <Loaders isLoading={true} name={'home'} />
            )}
        </Layout>
    )
}
export default Home
